import axiosInstance from '../config/axios';

// بيانات وهمية للمستخدمين
const mockUsers = [
    {
        id: 1,
        name: "أحمد محمد",
        email: "ahmed@example.com",
        role: "admin"
    },
    {
        id: 2,
        name: "سارة أحمد",
        email: "sara@example.com",
        role: "user"
    }
];

// بيانات وهمية للدورات
const mockCourses = [
    {
        id: 1,
        title: "دورة React JS",
        type: "recorded",
        description: "تعلم React من الصفر",
        instructor: "أحمد محمد",
        price: 199,
        rating: 4.5,
        students: 120
    },
    {
        id: 2,
        title: "دورة Node.js",
        type: "live",
        description: "تعلم Node.js من الصفر",
        instructor: "سارة أحمد",
        price: 299,
        rating: 4.8,
        students: 85
    }
];

// بيانات وهمية لإحصائيات لوحة التحكم
const mockDashboardStats = {
    totalStudents: 205,
    totalCourses: 2,
    totalRevenue: 47880,
    recentActivities: [
        { id: 1, type: "enrollment", user: "محمد علي", course: "دورة React JS", date: "2025-01-22" },
        { id: 2, type: "completion", user: "فاطمة أحمد", course: "دورة Node.js", date: "2025-01-21" }
    ]
};

// بيانات وهمية للتصنيفات
const mockCategories = [
    {
        id: 1,
        name: "الدورات التطويرية",
        description: "دورات لتطوير المهارات الشخصية والمهنية"
    },
    {
        id: 2,
        name: "الدورات التخصصية",
        description: "دورات متخصصة في مجالات محددة"
    },
    {
        id: 3,
        name: "STEP",
        description: "دورات تحضيرية لاختبار STEP"
    }
];

export const api = {
    // خدمات المصادقة
    auth: {
        login(email, password) {
            return axiosInstance.post('/auth/login', { email, password });
        },
        register(userData) {
            // استخدام المسار الصحيح كما هو في قائمة الراوتس
            // Registration data from API
            return axiosInstance.post('api/register', userData);
        },
        logout() {
            localStorage.removeItem('token');
        },
        isAuthenticated: () => {
            return true;
        },

        getUser: () => {
            return mockUsers[0];
        }
    },

    // خدمات الطلبات
    orders: {
        async submitOrder(orderData) {
            try {
                const response = await axiosInstance.post('/api/orders', orderData);
                return response.data;
            } catch (error) {
                console.error('Error submitting order:', error);
                throw error;
            }
        },

        async uploadReceipt(orderId, file) {
            try {
                const formData = new FormData();
                formData.append('receipt', file);
                
                const response = await axiosInstance.post(`/api/orders/${orderId}/receipt`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                return response.data;
            } catch (error) {
                console.error('Error uploading receipt:', error);
                throw error;
            }
        }
    },

    // خدمات التصنيفات للواجهة العامة
    publicCategories: {
        getAll: async () => {
            const response = await axiosInstance.get('/api/categories');
            return response.data;
        }
    },

    // خدمات التصنيفات للوحة التحكم
    categories: {
        getAll: async () => {
            const response = await axiosInstance.get('/api/admin/courses/categories/all');
            return response.data;
        },

        create: async (categoryData) => {
            const response = await axiosInstance.post('/api/admin/courses/categories', categoryData);
            return response.data;
        },

        update: async (id, categoryData) => {
            const response = await axiosInstance.put(`/api/admin/courses/categories/${id}`, categoryData);
            return response.data;
        },

        delete: async (id) => {
            await axiosInstance.delete(`/api/admin/courses/categories/${id}`);
        }
    },

    // خدمات لوحة التحكم
    dashboard: {
        getStats: async () => {
            return { success: true, data: mockDashboardStats };
        }
    },

    // خدمات الدورات
    courses: {
        getAllCourses: async () => {
            return mockCourses;
        },

        getRecordedCourses: async () => {
            return mockCourses.filter(course => course.type === 'recorded');
        },

        getRecentCourses: async () => {
            return mockCourses.slice(0, 5);
        },

        getLessons: async () => {
            return [
                { id: 1, title: "مقدمة في React", duration: "30:00", courseId: 1 },
                { id: 2, title: "Components في React", duration: "45:00", courseId: 1 }
            ];
        },

        createCourse: async (courseData) => {
            return { success: true, data: { id: mockCourses.length + 1, ...courseData } };
        },

        updateCourse: async (id, courseData) => {
            return { success: true, data: { id, ...courseData } };
        },

        deleteCourse: async (id) => {
            return { success: true };
        },

        exportCourses: async () => {
            return { success: true, data: mockCourses };
        }
    },

    // خدمات تجارب المستخدمين
    experiences: {
        getAll: () => axiosInstance.get('/api/experiences'),
        create: (data) => axiosInstance.post('/api/experiences', data),
        update: (id, data) => axiosInstance.put(`/api/experiences/${id}`, data),
        delete: (id) => axiosInstance.delete(`/api/experiences/${id}`)
    }
};
